import React from 'react';
import './LibraryPage.css';
import headerImg from './labrary.jpg';
import sectionImg1 from './labrary2.jpg';
import sectionImg2 from './kid.jpg';
import Footer from './Footer';

const LibraryPage = () => {
  return (
    <div className="library-page">
      {/* Header Section */}
      <div className="library-header">
        <img src={headerImg} alt="Library Header" className="header-image" />
        <div className="overlay" />
        <h1 className="header-title">Library</h1>
      </div>

      {/* Section with Two Divs */}
      <div className="library-sections">
        <div className="library-section">
          <img src={sectionImg1} alt="Bookshelves" className="section-image" />
          <div className="section-content">
            <h2>Modern Book Collection</h2>
            <p>
              Our library is stocked with a wide variety of modern literature, reference books,
              academic journals, and digital resources to support our students' educational journey.
              The modern layout creates a comfortable and inspiring environment for learning and
              research.
            </p>
          </div>
        </div>

        <div className="library-section">
          <img src={sectionImg2} alt="Reading Area" className="section-image" />
          <div className="section-content">
            <h2>Quiet Reading Area</h2>
            <p>
              A peaceful reading zone equipped with comfortable seating and proper lighting
              ensures that every student finds the perfect spot to concentrate. Whether it's for
              individual study or quiet group discussions, our reading area supports productive
              learning.
            </p>
          </div>
        </div>
      </div>
      <div>
        <Footer/>
      </div>
    </div>
  );
};

export default LibraryPage;
